export default [
  {
    path: '/users',
    name: 'users.index',
    meta: {
      title: '小程序用户管理',
      navbar: 'el-icon-user',
      permission: 'users.read'
    },
    component: require('./index').default
  },
  {
    path: '/users/:id',
    name: 'users.show',
    component: require('./show').default,
    meta: {
      title: '用户详情',
      permission: 'users.read'
    }
  }
]
